module.exports = __webpack_public_path__ + "media/icons/check-green-42bae683.svg";